import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getPlayTimerState } from '../selectors/getPlayTimer';
const PlayTimerContext = createContext();

export const DEFAULT_TIMER = '8.5s';
export const DEFAULT_TIMER_NUM = 8.5;

const setPlayerTime = (adjusted, playTimerState) => {
    const { standard, adjust } = playTimerState;
    const isAdjustedTimer = !!adjust.timer;

    if (!adjusted) {
        return {
            timer: standard.timing,
            timerNum: standard.timingNum,
            delay: standard.delay,
            adjusted: isAdjustedTimer
        };
    }

    return {
        timer: adjust.timer,
        timerNum: adjust.timerNum,
        delay: adjust.delay,
        adjusted: isAdjustedTimer
    };
};

const PlayTimeProvider = ({ adjusted = false, children }) => {
    const playTimerState = useSelector(getPlayTimerState);
    const timeState = setPlayerTime(adjusted, playTimerState);

    return (
        <PlayTimerContext.Provider value={timeState}>
            {children}
        </PlayTimerContext.Provider>
    );
};

PlayTimeProvider.propTypes = {
    children: PropTypes.node,
    adjusted: PropTypes.bool
};

export default PlayTimeProvider;
export { PlayTimerContext };
